module.exports = __webpack_public_path__ + "static/media/Marker.e8494196.svg";